import axios from 'axios';
import API_URL from '../config/api.js';
import { auth } from '../config/firebase';

/**
 * Get Firebase auth token if user is logged in
 */
const getAuthToken = async () => {
  const user = auth.currentUser;
  if (user) {
    try {
      return await user.getIdToken();
    } catch (error) {
      console.error('Failed to get auth token:', error);
    }
  }
  return null;
};

/**
 * Search for fashion items using an image.
 *
 * @param {string} imagePreview - Object URL or data URL of the image
 * @returns {Promise<Object>} Search results with matches and analysis
 * @throws {Error} If search fails
 */
export const searchFashion = async (imagePreview) => {
  try {
    const blob = await fetch(imagePreview).then((res) => res.blob());
    const formData = new FormData();
    formData.append('file', blob, 'image.jpg');

    // Build headers with auth token if available
    const headers = {
      'Content-Type': 'multipart/form-data',
    };

    // Add Authorization header if user is authenticated
    const token = await getAuthToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await axios.post(`${API_URL}/search`, formData, {
      headers,
      timeout: 90000, // 90 seconds timeout for analyzing/search
    });
    return response.data;
  } catch (error) {
    console.error('Error searching for fashion:', error);

    let errorMessage = 'Failed to search for fashion. ';
    if (error.response?.data?.detail) {
      errorMessage += error.response.data.detail;
    } else if (error.message) {
      errorMessage += error.message;
    } else {
      errorMessage += 'Please try again.';
    }
    throw new Error(errorMessage);
  }
};

export default searchFashion;

